const cachios = require('cachios');
const axios = require('axios');

// Only the real production hostname reaches the production API; localhost uses
// the bare dev server, and anything else (.lan addresses) fails safe to the
// Caddy-proxied dev API — never production.
const apiUrl = (location.hostname === 'portal.my247ed.com') ? 'https://api.my247ed.com/portal/'
: (location.hostname === 'localhost') ? 'http://localhost:3000/portal/'
: 'https://api.my247ed.lan/portal/';
const axiosInstance = axios.create({
    baseURL:  apiUrl
});

import axiosRetry from 'axios-retry';

axiosRetry(axiosInstance, {
    retries: 10,
    retryDelay: axiosRetry.exponentialDelay
});

// all requests will now use this axios instance
// const client = cachios.create(axiosInstance, {
//     stdTTL: 120
// });

let client = axiosInstance;

export {client, axiosInstance, apiUrl};
